import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import dayjs from 'dayjs';
import type { PanelCard, PanelCards, GetPanelCards } from './types';
import { checkInvalidDate } from '../../Application/graphql';
import { type FundingSource } from '../../Nomination/components';

const GET_PANEL_CARDS = gql`
  query ($filter: PanelFilter) {
    panels(filter: $filter) {
      _id
      fundingSource
      title
      panelType
      startDate
      endDate
    }

    getFundingSourceConfiguration {
      mapping
    }
  }
`;

const NA = 'N/A';
export const useGetPanelCards = (filter: any): GetPanelCards => {
  const { data, loading, error, refetch } = useQuery(GET_PANEL_CARDS, {
    variables: { filter },
    fetchPolicy: 'network-only',
  });

  const panels = data?.panels ?? [];
  const competitiveFundingSource =
    data?.getFundingSourceConfiguration?.mapping?.COMPETITIVE ?? [];

  const panelCardsList: PanelCards[] = competitiveFundingSource.map(
    (fundingSource: any) => {
      return {
        fundingSource: fundingSource?.label ?? '',
        funding: fundingSource?.value as FundingSource,
        panelCards: panels
          .filter((panel: any) => panel.fundingSource === fundingSource.value)
          .map((panel: any) => {
            const { _id, title, panelType, startDate, endDate } = panel;
            return {
              panelId: _id ?? '',
              title: title ?? NA,
              panelType: panelType ?? NA,
              startDate: checkInvalidDate(startDate)
                ? NA
                : dayjs(startDate).format('DD/MM/YYYY'),
              endDate: checkInvalidDate(endDate)
                ? NA
                : dayjs(endDate).format('DD/MM/YYYY'),
            };
          }) as PanelCard[],
      };
    },
  );

  return {
    panelCardsList,
    loading,
    error,
    refetch,
  };
};
